import Administration from '@/views/Administration/Index'
import AdministrationRoomReservations from '@/views/Administration/RoomReservations/Index'
import AdministrationCarReservations from '@/views/Administration/CarReservations/Index'
import AdministrationUsers from '@/views/Administration/Users/Index'
import AdministrationCostCenterNumbers from '@/views/Administration/CostCenterNumbers/Index'


export default [
    {
        path: '/administration',
        name: 'administration',
        component: Administration,
        meta: {
            title: 'Administracja',
            menuRendered: true,
            menuTitle: 'Administracja',
            icon: 'mdi-domain'
        },
        children: [
            {
                path: '/administration/room-reservations',
                name: 'administrationRoomReservations',
                component: AdministrationRoomReservations,
                meta: {
                    title: 'Administracja / Rezerwacja salek',
                    menuRendered: true,
                    menuTitle: 'Rezerwacja salek',
                    requiresAuth: true,
                    permission: 'room_reservations',
                },
            },
            {
                path: '/administration/car-reservations',
                name: 'administrationCarReservations',
                component: AdministrationCarReservations,
                meta: {
                    title: 'Administracja/ Rezerwacja aut',
                    menuRendered: true,
                    menuTitle: 'Rezerwacja aut',
                    requiresAuth: true,
                    permission: 'car_reservations',
                },
            },
            {
                path: '/administration/users',
                name: 'administrationUsers',
                component: AdministrationUsers,
                meta: {
                    title: 'Administracja / Użytkownicy',
                    menuRendered: true,
                    menuTitle: 'Użytkownicy',
                    requiresAuth: true,
                    permission: 'superadmin',
                }
            },
            {
                path: '/administration/cost-center-numbers',
                name: 'administrationCostCenterNumbers',
                component: AdministrationCostCenterNumbers,
                meta: {
                    title: 'Administracja / Baza MPK',
                    menuRendered: true,
                    menuTitle: 'Baza MPK',
                    requiresAuth: true,
                    permission: 'finances',
                }
            },
        ],
    },
]
